//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscLearnFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 13.74V17.54V17.61L12 21.65L19 17.61V13.74L12 17.78L5 13.74Z" fill="currentColor" /><path d="M12 3.35001L1 9.70001L12 16.05L19.92 11.47L21 10.85V19H23V9.70001L12 3.35001Z" fill="currentColor" /></svg>;
}
export default IconMiscLearnFill;